import { api } from './api';

function getApiBaseUrl(): string {
  const raw = String((api.defaults.baseURL as any) || '').trim();
  return raw.replace(/\/+$/, '');
}

export function toAbsoluteApiMediaUrl(url?: string | null): string | undefined {
  const u = String(url ?? '').trim();
  if (!u) return undefined;

  if (/^(data:|blob:)/i.test(u)) return u;
  if (/^https?:\/\//i.test(u)) return u;

  const looksLikeApiMedia =
    u.startsWith('/uploads/') ||
    u.startsWith('uploads/') ||
    u.startsWith('/uploads\\') ||
    u.startsWith('uploads\\');

  if (!looksLikeApiMedia) return u;

  const base = getApiBaseUrl();
  if (!base) return u;

  return u.startsWith('/') ? `${base}${u}` : `${base}/${u}`;
}

